module.exports = function getResource(label, vars = []) {
    let resources = {
        filterBy: 'Filter by',
        filter: 'Filter',
        resetAllFilters: 'Reset all filters',
        reset: 'Reset',
        done: 'Done'
    };

    return resources[label];
};
